module.exports = __webpack_public_path__ + "static/media/Foreign_ID.cb91ddf4.svg";